import "./sponsorList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import SponsorTable from "../sponsortable/SponsorTable";

const SponsorList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <SponsorTable />
      </div>
    </div>
  );
};

export default SponsorList;
